import { inject, Pipe, PipeTransform } from '@angular/core';
import {
  DomSanitizer,
  SafeHtml,
  SafeResourceUrl,
  SafeScript,
  SafeStyle,
  SafeUrl,
} from '@angular/platform-browser';
import { SAFE_TYPE } from '@shared/constants';
import { SafeType } from '@shared/models';

@Pipe({
  name: 'safe',
  standalone: true,
})
export class SafePipe implements PipeTransform {
  protected readonly sanitizer = inject(DomSanitizer);

  transform(
    value: string,
    type: SafeType = 'html'
  ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case SAFE_TYPE.HTML:
        return this.sanitizer.bypassSecurityTrustHtml(value || '');
      case SAFE_TYPE.STYLE:
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case SAFE_TYPE.SCRIPT:
        return this.sanitizer.bypassSecurityTrustScript(value);
      case SAFE_TYPE.URL:
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case SAFE_TYPE.RESOURCE_URL:
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}
